export default __webpack_public_path__ + "static/media/rolamento.d970496b.png";